import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import UserPage from "./pages/UserPage";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import "./App.css";
import MechanicHome from "./pages/MechanicHome";
import Quotes from "./pages/Quotes";
import AdminRequests from "./pages/AdminRequests";
import AdminRequestDetail from "./components/AdminRequestDetail";
import CreateQuote from "./pages/CreateQuote";
import QuoteDetails from "./pages/QuoteDetails";
import QuotesList from "./pages/QuotesList";
import CommentsInbox from "./pages/CommentsInbox";
import CustomersList from "./pages/Customerslist";
import UserComments from "./pages/Usercomments";
import AdminNotifications from "./pages/Adminnotifications";
import UserNotifications from "./pages/Usernotifications";
import FindPartsPage from "./pages/Findpartspage";
import CustomerDetail from "./pages/CustomerDetail";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import About from "./pages/About";
import Support from "./pages/Support";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import QuoteHistory from "./pages/QuoteHistory";
import Register from "./pages/Register";
import Team from "./pages/Team";
import DesktopNotifications from "./components/DesktopNotifications";

// Staff area: admins and workers. adminOnly pages are for admins only.
function ProtectedAdmin({ children, adminOnly = false }) {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  if (!user || !localStorage.getItem("token")) return <Navigate to="/admin/login" replace />;
  if (!["admin", "worker"].includes(user.role)) return <Navigate to="/" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/admin/dashboard" replace />;
  return children;
}

function RequireAuth({ children, role }) {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  if (!user || !localStorage.getItem("token")) return <Navigate to="/user/login" replace />;
  if (role && user.role !== role) return <Navigate to="/quotes" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <DesktopNotifications />
      <Routes>
        <Route path="/" element={<UserPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/user/login" element={<Login mode="user" />} />
        <Route path="/admin/login" element={<Login mode="admin" />} />
        <Route path="/Register" element={<Register />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route
          path="/about"
          element={
            new URLSearchParams(window.location.search).get("app") === "1" ? (
              <About />
            ) : (
              <RequireAuth>
                <About />
              </RequireAuth>
            )
          }
        />
        <Route
          path="/support"
          element={
            new URLSearchParams(window.location.search).get("app") === "1" ? (
              <Support />
            ) : (
              <RequireAuth>
                <Support />
              </RequireAuth>
            )
          }
        />
        <Route
          path="/privacy-policy"
          element={
            new URLSearchParams(window.location.search).get("app") === "1" ? (
              <PrivacyPolicy />
            ) : (
              <RequireAuth>
                <PrivacyPolicy />
              </RequireAuth>
            )
          }
        />
        {/* <Route path="/support" element={<Support />} /> */}
        {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
        <Route
          path="/home"
          element={
            <RequireAuth>
              <MechanicHome />
            </RequireAuth>
          }
        />
        <Route
          path="/notifications"
          element={
            <RequireAuth>
              <UserNotifications />
            </RequireAuth>
          }
        />
        <Route
          path="/quotes"
          element={
            <RequireAuth>
              <Quotes />
            </RequireAuth>
          }
        />
        <Route
          path="/quotes/:id"
          element={
            <RequireAuth>
              <QuoteDetails />
            </RequireAuth>
          }
        />
        {/* <Route
          path="/search"
          element={
            <RequireAuth>
              <FindPartsPage />
            </RequireAuth>
          }
        /> */}
        <Route
          path="/search"
          element={
            new URLSearchParams(window.location.search).get("app") === "1" ? (
              <FindPartsPage />
            ) : (
              <RequireAuth>
                <FindPartsPage />
              </RequireAuth>
            )
          }
        />
        <Route
          path="/comments"
          element={
            <RequireAuth>
              <UserComments />
            </RequireAuth>
          }
        />



        <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
        <Route path="/quotes/:id/history" element={<RequireAuth><QuoteHistory /></RequireAuth>} />
        {/* admin panel */}
        <Route
          path="/admin/notifications"
          element={
            <ProtectedAdmin>
              <AdminNotifications />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedAdmin>
              <Dashboard />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/requests"
          element={
            <ProtectedAdmin>
              <AdminRequests />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/requests/:id"
          element={
            <ProtectedAdmin>
              <AdminRequestDetail />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/requests/:id/quote"
          element={
            <ProtectedAdmin>
              <CreateQuote />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/quotes"
          element={
            <ProtectedAdmin>
              <QuotesList />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/comments"
          element={
            <ProtectedAdmin>
              <CommentsInbox />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/customers"
          element={
            <ProtectedAdmin adminOnly>
              <CustomersList />
            </ProtectedAdmin>
          }
        />
        <Route
          path="/admin/customers/:id"
          element={
            <ProtectedAdmin adminOnly>
              <CustomerDetail />
            </ProtectedAdmin>
          }
        />
        <Route path="/admin/team" element={<ProtectedAdmin adminOnly><Team /></ProtectedAdmin>} />
        <Route
          path="/admin/settings"
          element={
            <ProtectedAdmin>
              <Settings />
            </ProtectedAdmin>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}